<template>
  <base-dialog
    :action="onAction"
    :action-name="actionName"
    :close="onClose"
    :title="'Refund payment'"
  >
    <template #activator="{ on }">
      <slot
        name="activator"
        v-bind="{ on }"
      />
    </template>

    <template #content>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-alert
              type="info"
              border="left"
              outlined
            >
              Refunds take 5-10 days to appear on a customer's statement.
            </v-alert>

            <v-row>
              <v-col cols="8">
                <amount-input
                  :init-amount="parseInt(refundAmount, 10)"
                  @change="updateRefundAmount"
                />
                <span class="error--text">{{ refundHint }}</span>
              </v-col>
              <v-col cols="4">
                of remaining <br>
                <span v-money="{ amount: getRefundAmount(), currency: model.currency}"></span>
              </v-col>
            </v-row>

            <v-select
              dense
              outlined
              v-model="selectedReason"
              label="Reason"
              :items="reasons"
              item-value="id"
              item-text="name"
            />
          </v-col>
        </v-row>
      </v-container>
    </template>
  </base-dialog>
</template>

<script>
import { mapActions } from 'vuex'
import { get, isEmpty } from 'lodash'
import BaseDialog from "../Common/BaseDialog"
import AmountInput from "../Common/AmountInput"
import { formatMoney } from "../../services/util.service"

export default {
  components: { AmountInput, BaseDialog },
  props: {
    id: {
      type: String,
      default: ''
    },
  },
  data() {
    return {
      model: {},
      refundAmount: 0,
      selectedReason: 'requested_by_customer',
      reasons: [
        {
          id: 'duplicate',
          name: 'Duplicate'
        },
        {
          id: 'fraudulent',
          name: 'Fraudulent'
        },
        {
          id: 'requested_by_customer',
          name: 'Requested by customer'
        },
      ]
    }
  },
  computed: {
    actionName() {
      return this.isRefundFullAmount() || isEmpty(this.refundAmount)
        ? 'Refund'
        : `Refund $${this.refundAmount} ${this.model.currency}`
    },

    refundHint() {
      let hint = ''
      let moneyText = ''
      if (parseInt(this.refundAmount, 10) === 0) {
        moneyText = formatMoney({amount: this.refundAmount, currency: this.model.currency})
        hint = `Refund amount cannot be ${moneyText}.`
      }

      if (parseInt(this.refundAmount, 10) > this.getRefundAmount()) {
        moneyText = formatMoney({ amount: this.getRefundAmount(), currency: this.model.currency})
        hint = `Refund cannot be more than ${moneyText}.`
      }

      return hint
    }
  },
  async created() {
    const payload = {
      id: this.id
    }
    const payment = await this.getPayment(payload)

    this.model = { ...payment }

    this.refundAmount = this.getRefundAmount()
  },
  methods:{
    ...mapActions(['createRefund', 'getPayment']),
    updateRefundAmount(amount) {
      this.refundAmount = parseInt(amount)
    },
    getRefundAmount() {
      const charge = this.getCharge()
      const amount = get(charge, 'amount', 0)
      const amountRefunded = get(charge, 'amount_refunded', 0)

      const total = amount - amountRefunded

      return total
    },
    isRefundFullAmount() {
      const charge = this.getCharge()
      const amount = get(charge, 'amount', 0)
      const refundAmount = parseInt(this.refundAmount, 10)

      return amount === refundAmount && refundAmount > 0
    },
    getCharge() {
      return get(this.model, 'charges.data[0]', {})
    },
    onClose(){
      this.$emit('close')
    },
    async onAction() {
      const charge = this.getCharge();

      const payload = {
        charge: charge.id,
        amount: this.refundAmount,
        reason: this.selectedReason
      }
      await this.createRefund(payload)

      this.$emit('action', payload)
    }
  }
}
</script>
